import React from 'react'
import get from 'lodash/get'
import { i18n } from '../../index'
import { Query } from 'react-apollo'
import { Button } from '@mui/material'
import Loader from '../../../common/loader/Loader'
import StationPage from './StationPage'
import NightTaskTable from './NightTaskTable'
import NightTaskDialog from './NightTaskDialog'
import { fetchNightTasks } from '../../station/stationQueries'
import type { NightTask } from '../../station/stationTypes'
import css from './stationPage.css'

type StationNightTaskPageState = {
  isDialogOpen: boolean
  data: NightTask | null | undefined
}

class StationNightTaskPage extends React.PureComponent<any, StationNightTaskPageState> {
  state = {
    isDialogOpen: false,
    data: null,
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      data: null,
    })
  }
  onEdit = (data: NightTask) => {
    this.setState({
      data,
    })
    this.openDialog()
  }

  render() {
    const { isDialogOpen, data } = this.state
    return (
      <StationPage title={i18n.t('admin.stations.title.nightTaskPage')}>
        {({ station }) => (
          <div className={css.component}>
            <Query<
              {
                nightTasks: Array<NightTask>
              },
              {
                stationId: string
              }
            >
              query={fetchNightTasks}
              variables={{
                stationId: station.id,
              }}
            >
              {({ loading, error, data }) => (
                <Loader
                  {...{
                    loading,
                    error,
                  }}
                >
                  <NightTaskTable
                    data={get(data, 'stationNightTasks', [])}
                    stationId={station.id}
                    onEdit={this.onEdit}
                  />
                </Loader>
              )}
            </Query>
            <div className={css.bottom}>
              <Button onClick={this.openDialog} variant='contained' color='primary'>
                {i18n.t('buttons.create')}
              </Button>
            </div>
            <NightTaskDialog data={data} stationId={station.id} isOpen={isDialogOpen} onClose={this.closeDialog} />
          </div>
        )}
      </StationPage>
    )
  }
}

export default StationNightTaskPage
